"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewChild = function NewChild() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "6",
    height: "16",
    viewBox: "0 0 6 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.998 3.49999C2.56725 3.49999 2.20028 3.34774 1.89708 3.04324C1.59388 2.73874 1.44228 2.37112\n1.44228 1.94037C1.44228 1.50962 1.59453 1.14264 1.89903 0.839444C2.20353 0.536244 2.57115 0.384644\n3.0019 0.384644C3.43265 0.384644 3.79963 0.536894 4.10283 0.841394C4.40603 1.14588 4.55763 1.5135\n4.55763 1.94427C4.55763 2.37502 4.40538 2.74199 4.10088 3.04519C3.79638 3.34839 3.42875 3.49999\n2.998 3.49999ZM1.3269 15.4807V10.673H0.326904V6.21152C0.326904 5.75142 0.490721 5.35755 0.818354\n5.02992C1.146 4.70229 1.53987 4.53847 1.99995 4.53847H3.99995C4.46004 4.53847 4.8539 4.70229\n5.18155 5.02992C5.50919 5.35755 5.673 5.75142 5.673 6.21152V10.673H4.673V15.4807H1.3269Z",
    fill: "#6E6D71"
  }));
};
var _default = NewChild;
exports.default = _default;